import weddingRings from '../../wedding-rings-96.png';
import './style.css';

function Title() {
  return (
    <header className="app-header">
      {/*<span>Bride</span>*/}
      <img src={weddingRings} className="wedding-rings" alt="wedding-rings" />
      <span className="app-title">Hochzeit</span>
      <img src={weddingRings} className="wedding-rings" alt="wedding-rings" />
    </header>
  );
}

export default Title;
